import { render, staticRenderFns } from "./RequiresSignature.vue?vue&type=template&id=0af4e6da&scoped=true&"
import script from "./RequiresSignature.vue?vue&type=script&lang=js&"
export * from "./RequiresSignature.vue?vue&type=script&lang=js&"
import style0 from "./RequiresSignature.vue?vue&type=style&index=0&id=0af4e6da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4e6da",
  null
  
)

export default component.exports